import React from 'react'

/* Network-share glyph, the same design handoff asset the training report's Share button
   uses (iconsax linear Share), so the two pages carry one "share" mark. */
const ShareNodes = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M6.40991 15.1598C8.15513 15.1598 9.57007 13.745 9.57007 11.9998C9.57007 10.2546 8.15513 8.83984 6.40991 8.83984C4.66469 8.83984 3.25 10.2546 3.25 11.9998C3.25 13.745 4.66469 15.1598 6.40991 15.1598Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5898 8.32C19.3351 8.32 20.7498 6.90522 20.7498 5.16C20.7498 3.41478 19.3351 2 17.5898 2C15.8446 2 14.4297 3.41478 14.4297 5.16C14.4297 6.90522 15.8446 8.32 17.5898 8.32Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5898 21.9997C19.3351 21.9997 20.7498 20.585 20.7498 18.8397C20.7498 17.0945 19.3351 15.6797 17.5898 15.6797C15.8446 15.6797 14.4297 17.0945 14.4297 18.8397C14.4297 20.585 15.8446 21.9997 17.5898 21.9997Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.09961 10.3407L14.8894 6.80078"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.09961 13.6602L14.8894 17.2002"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ShareNodes
